import { v4 as uuidv4 } from "uuid";
import {
  getMarginOptions,
  getPaddingOptions,
} from "@/react/components/shared/BuilderUI/utils/boxModelStyleHelpers";
import { getBackgroundColorOptions } from "@/react/components/shared/BuilderUI/utils/buttonStyleHelpers";
import { getBorderRadiusOptions } from "@/react/components/shared/BuilderUI/utils/imgStyleHelpers";
import { getSizingOptions } from "@/react/components/shared/BuilderUI/utils/sizeStyleHelpers";
import {
  getColorOptions,
  getTextAlignOptions,
} from "@/react/components/shared/BuilderUI/utils/textStyleHelpers";
import { defaultData as defaultPData } from "@/react/components/shared/Emails/VisualEmailBuilder/Blocks/Content/PBlock/P1BlockDefaultData";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import { createImageBlock } from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/mediaBlockHelpers";
import {
  createH2Block,
  createPBlock,
} from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/textBlocksHelpers";
import { defaultData as defaultImageData } from "@circle-react-shared/Emails/VisualEmailBuilder/Blocks/Content/ImgBlock/ImgBlockDefaultData";
import placeholderImage from "@circle-react-shared/Emails/VisualEmailBuilder/Blocks/Content/ImgBlock/img_preview_dark.png";
import { defaultData as defaultH2Data } from "@circle-react-shared/Emails/VisualEmailBuilder/Blocks/Headings/H2Block/H2BlockDefaultData";
import { defaultStyles } from "./defaultStyles";

const imageBlockStyles = {
  sizing: getSizingOptions({
    defaultValue: {
      width: "100%",
      height: "200px",
      minWidth: "auto",
      minHeight: "auto",
      maxWidth: "100%",
      maxHeight: "200px",
    },
  }),
  borderRadius: getBorderRadiusOptions({
    defaultValue: {
      border_left_top_radius: 12,
      border_left_bottom_radius: 12,
      border_right_top_radius: 12,
      border_right_bottom_radius: 12,
    },
  }),
  margin: getMarginOptions({
    defaultValue: {
      marginTop: "12",
      marginBottom: "12",
      marginLeft: "24",
      marginRight: "24",
    },
  }),
};

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "ImageGalleryBlock1",
  props: {
    headerContent: {
      prop: "children",
      type: "children",
      value: [
        createH2Block({
          text: "Image Gallery",
          baseData: defaultH2Data,
          styles: {
            textAlign: getTextAlignOptions("center"),
            color: getColorOptions(defaultStyles.color),
            margin: getMarginOptions({
              defaultValue: {
                marginTop: "12",
                marginBottom: "12",
                marginLeft: "24",
                marginRight: "24",
              },
            }),
          },
        }),
        createPBlock({
          text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
          baseData: defaultPData,
          styles: {
            textAlign: getTextAlignOptions("center"),
            color: getColorOptions(defaultStyles.color),
            margin: getMarginOptions({
              defaultValue: {
                marginTop: "12",
                marginBottom: "48",
                marginLeft: "24",
                marginRight: "24",
              },
            }),
          },
        }),
      ],
    },
    imageNode1: {
      prop: "children",
      type: "children",
      value: [
        createImageBlock({
          signedId: "",
          alt: "Gallery image 1",
          placeholder: placeholderImage,
          baseData: defaultImageData,
          styles: {
            ...imageBlockStyles,
            margin: getMarginOptions({
              defaultValue: {
                marginTop: "12",
                marginBottom: "12",
                marginLeft: "24",
                marginRight: "8",
              },
            }),
          },
        }),
      ],
    },
    imageNode2: {
      prop: "children",
      type: "children",
      value: [
        createImageBlock({
          signedId: "",
          alt: "Gallery image 2",
          placeholder: placeholderImage,
          baseData: defaultImageData,
          styles: {
            ...imageBlockStyles,
            margin: getMarginOptions({
              defaultValue: {
                marginTop: "12",
                marginBottom: "12",
                marginLeft: "16",
                marginRight: "16",
              },
            }),
          },
        }),
      ],
    },
    imageNode3: {
      prop: "children",
      type: "children",
      value: [
        createImageBlock({
          signedId: "",
          alt: "Gallery image 3",
          placeholder: placeholderImage,
          baseData: defaultImageData,
          styles: {
            ...imageBlockStyles,
            margin: getMarginOptions({
              defaultValue: {
                marginTop: "12",
                marginBottom: "12",
                marginLeft: "8",
                marginRight: "24",
              },
            }),
          },
        }),
      ],
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        backgroundColor: getBackgroundColorOptions({
          defaultValue: defaultStyles.backgroundColor,
        }),
        textAlign: getTextAlignOptions("center"),
        padding: getPaddingOptions({
          defaultValue: defaultStyles.padding,
        }),
        margin: getMarginOptions({
          defaultValue: defaultStyles.margin,
        }),
      },
    },
  },
};
